var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterXDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.556,
    height: 18.49,
    viewBox: "0 0 19.556 18.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M2300.235,45.364l7.386-7.921h-1.805l-6.382,6.844-5.111-6.844h-5.684l7.637,10.227-7.7,8.263h1.809l6.7-7.186,5.367,7.186h5.681Zm-2.237,2.4-.8-1.077-5.918-7.924h2.385l4.857,6.5.8,1.074,6.171,8.266h-2.384Z",
    transform: "translate(-2288.572 -37.443)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterXDark);
export default __webpack_public_path__ + "static/media/twitter-X-dark.43bfa7fd31a07cda533aae736b05450a.svg";
export { ForwardRef as ReactComponent };